import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=7c8881ca&scoped=true"
import script from "./CreateDialog.vue?vue&type=script&lang=js"
export * from "./CreateDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateDialog.vue?vue&type=style&index=0&id=7c8881ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8881ca",
  null
  
)

export default component.exports